import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { CONVERSATIONS_ENDPOINT } from './constants';
import { getApiErrorMessage } from './getApiErrorMessage';
import { TChannelSendResult, TSendChannelMessageBody } from './types';

const ERROR_CANNOT_SEND_MESSAGE = 'Errors.CannotSendWsp';

/**
 * Sends a message (text, one media file or a note) on a `WarboxConversation`.
 * The only call to `/conversations/sendMessage`.
 *
 * @throws Error whose message is the backend error (e.g. `Errors.SessionMessageRequiresInbound`)
 */
export const sendChannelMessage = async (
    body: TSendChannelMessageBody
): Promise<TChannelSendResult> => {
    try {
        const response = await ApiV2.post(
            CONVERSATIONS_ENDPOINT.SEND_MESSAGE,
            body,
            HEADERS()
        );
        return response.data?.data;
    } catch (error) {
        throw new Error(getApiErrorMessage(error, ERROR_CANNOT_SEND_MESSAGE));
    }
};
